
import React from 'react';

export const getContentType = (content: any): string => {
  if (content === null) return "Empty"
  
  // Handle color blocks
  if (typeof content === 'object' && 'type' in content) {
    if (content.type === 'color') {
      if (content.style.includes('gradient')) {
        return "Gradient"
      }
      return "Block"
    }
  }
  
  if (React.isValidElement(content)) {
    const elementType = content.type as any
    if (typeof elementType === 'function' && elementType.displayName === 'MiniProfileBox') {
      return "Profile"
    }

    const props = content.props as Record<string, unknown>
    
    // Check for bulletin groups
    if (
      typeof props === 'object' && 
      props !== null && 
      'className' in props && 
      typeof props.className === 'string' && 
      props.className.includes('group')
    ) {
      return "Bulletin"
    }
    
    // Check for links after bulletins to maintain priority
    if (typeof props === 'object' && props !== null && 'href' in props) {
      return "Link"
    }
  }
  
  return "Other"
}
